import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { DataTableWrapper } from "../../../../components/data/DataTable";
import PageWrapper from "../../../../components/layouts/PageWrapper";
import Spinner from "../../../../components/Spinner";
import { Booking } from "../../../../interfaces/Booking";
import { getBookingAsync } from "../../../../redux/reducers/bookings/actions";
import { RootState } from "../../../../redux/rootReducers";

const ReportSecurity = () => {
  const dispatch = useDispatch();

  const bookings = useSelector((state: RootState) => state.booking.bookings);
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  
  const populateData = () => {
    dispatch(getBookingAsync.request({ page: 0 }));
  };

  useEffect(() => {
    populateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderRooms = (subBooking: Booking) => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={6} className="tablewrapper--loading">
            <div className="tablewrapper--loading--caption">
              <Spinner size="small" />
              <span>Memuat data...</span>
            </div>
          </td>
        </tr>
      );
    }

    if (subBooking.rooms.length > 0) {
      const newRooms = [...subBooking.rooms];
      newRooms.splice(0, 1);
      return subBooking.rooms.map(room => {
        return (
          <React.Fragment>
            <tr key={subBooking.id}>
              <td>{room.room_detail?.room_name}, {room.room_detail?.room_building}</td>
              <td>{subBooking.description}</td>
              <td>{moment(subBooking.start_date).format('DD MMM YYYY')}</td>
              <td>{moment(subBooking.start_date).format('HH:MM')}</td>
              <td>{moment(subBooking.end_date).format('HH:MM')}</td>
              <td>{subBooking.user_detail?.name}</td>
              <td></td>
              <td></td> 
            </tr>
          </React.Fragment>
        );
      })
    } else {
      return (
        <tr>
          <td colSpan={7}>No booking data was found</td>
        </tr>
      );
    }
  }

  const renderBookingList = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={6} className="tablewrapper--loading">
            <div className="tablewrapper--loading--caption">
              <Spinner size="small" />
              <span>Memuat data...</span>
            </div>
          </td>
        </tr>
      );
    }

    if (bookings.length > 0) {
      return bookings.map(booking => {
        return (
          <React.Fragment>
            <tr key={booking.id}>
              <td>{booking.rooms[0].room_detail?.room_name}, {booking.rooms[0].room_detail?.room_building}</td>
              <td>{booking.description}</td>
              <td>{moment(booking.start_date).format('DD MMM YYYY')}</td>
              <td>{moment(booking.start_date).format('HH:MM')}</td>
              <td>{moment(booking.end_date).format('HH:MM')}</td>
              <td>{booking.user_detail?.name}</td>
              <td></td>
              <td></td> 
            </tr>
            {renderRooms(booking)}
          </React.Fragment>
        );
      })
    } else {
      return (
        <tr>
          <td colSpan={7}>No booking data was found</td>
        </tr>
      );
    }
  }

  return (
    <PageWrapper>
      <ReportSecurityWrapper>
        <DataTableWrapper>
          <div className="tablewrapper--title">
            Daftar Peminjaman Ruangan
          </div>
          <div className="tablewrapper--table">
            <table>
              <thead>
                <tr>
                  <th>Ruangan</th>
                  <th>Deskripsi</th>
                  <th>Tanggal</th>
                  <th>Mulai</th>
                  <th>Selesai</th>
                  <th>PIC</th>
                  <th>TTD Ambil</th>
                  <th>TTD Kembali</th>
                </tr>
              </thead>
              <tbody>
                {renderBookingList()}
              </tbody>
            </table>
          </div>
        </DataTableWrapper>
      </ReportSecurityWrapper>
    </PageWrapper>
  )
}

const ReportSecurityWrapper = styled.div`
  @media print {
    @page { size: landscape; }
  }
`;

export default ReportSecurity;